import React, { useEffect, useState } from 'react'
import Layout from '../../Components/Layout'
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import EmployeeReson from './EmployeeReson';
import ExitInterviewQuestion from '../OffboardingConfig/ExitInterviewQuestion';
import OffboardingEmployeeStatus from './OffboardingEmployeeStatus';
import CompleteExitInterview from './CompleteExitInterview';
import "../../Assets/CSS/EmployeeOffboarding.css";
import axios from 'axios';

const EmployeeOffboarding = () => {

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("empreson");
    const [hasCreatedRequest, setHasCreatedRequest] = useState(false);
    const [hasCompletedInterview, setHasCompletedInterview] = useState(false);
    const [requestId, setRequestId] = useState(null);
    const token = localStorage.getItem("token");

    // 🔥 CHECK OFFBOARDING REQUEST ON LOAD
    useEffect(() => {
        fetchMyOffboardingRequest();
    }, []);

    const fetchMyOffboardingRequest = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/my-requests`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res.data && res.data.length > 0) {
                const existingRequest = res.data[0];

                setHasCreatedRequest(true);
                setRequestId(existingRequest.requestId);

                // 🔥 Check interview submission
                try {
                    await axios.get(
                        `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/exit-interview-questions-answers/${existingRequest.requestId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                    // Interview exists
                    setHasCompletedInterview(true);
                    setActiveTab("offboadringEmp");

                } catch (err) {
                    // Interview not found
                    setHasCompletedInterview(false);
                    setActiveTab("cexitIntervie");
                }

            } else {
                setHasCreatedRequest(false);
                setHasCompletedInterview(false);
                setActiveTab("empreson");
            }

        } catch (error) {
            console.error("Failed to fetch offboarding request", error);
        }
    };

    const handleTabClick = (tab) => {

        // First Time User
        if (!hasCreatedRequest) {
            if (tab !== "empreson") return;
        }

        // Request Created
        else if (hasCreatedRequest && !hasCompletedInterview) {
            if (tab === "empreson") return;
            if (tab === "offboadringEmp") return;
        }

        // Interview Submitted
        else if (hasCompletedInterview) {
            if (tab !== "offboadringEmp") return;
        }

        setActiveTab(tab);
    };


    return (
        <Layout>
            <div className="backgound-main-content p-3">         {/* TAB BUTTONS */}
                <div>
                    <p className="card-heading" style={{ margin: '0px', padding: '0px' }}>My Offboarding</p>
                    <p className="sub-card-heading" style={{ margin: '0px', padding: '0px', marginTop: '4px', }}>
                        Track your exit process and complete required actions
                    </p>
                </div>
                <div className="d-flex gap-2 mt-4">

                    {/* Create Offboarding empreson TAB */}


                    <button
                        className={activeTab === "empreson" ? "EmployeeStep" : "EmployeeStepBefore"}
                        // onClick={() => setActiveTab("empreson")}
                        onClick={() => handleTabClick("empreson")}
                        disabled={hasCreatedRequest}


                    >
                        <div className="tab-content-wrapper">
                            <div className="tab-left">
                                <Icon icon="proicons:person" />
                                <span>Create Offboarding</span>
                            </div>
                        </div>

                        <div className="tab-right">
                            {(activeTab === "cexitIntervie" || activeTab === "letter" || activeTab === "offboadringEmp") ? (
                                <Icon icon="weui:done2-filled" className="tab-right-icon" />
                            ) : (
                                <span className="tab-placeholder-icon" />
                            )}
                        </div>
                    </button>


                    {/* Complete Exit Interview */}
                    <button
                        className={activeTab === "cexitIntervie" ? "EmployeeStep" : "EmployeeStepBefore"}
                        onClick={() => handleTabClick("cexitIntervie")}
                        disabled={!hasCreatedRequest || hasCompletedInterview}
                    >

                        <div className="tab-content-wrapper">
                            <div className="tab-left">
                                <Icon icon="icon-park-outline:write" />
                                <span>Complete Exit Interview</span>
                            </div>


                        </div>


                        <div className="tab-right">
                            {(activeTab === "offboadringEmp" || activeTab === "letter") ? (
                                <Icon icon="weui:done2-filled" className="tab-right-icon" />
                            ) : (
                                <span className="tab-placeholder-icon" />   // 👈 placeholder
                            )}
                        </div>

                    </button>
                    <button
                        className={activeTab === "offboadringEmp" ? "EmployeeStep" : "EmployeeStepBefore"}
                        onClick={() => handleTabClick("offboadringEmp")}
                        disabled={!hasCompletedInterview}
                    >
                        <div className="tab-content-wrapper">
                            <div className="tab-left">
                                <Icon icon="material-symbols:pending" />
                                <span>Approval Status</span>
                            </div>
                        </div>
                        <div className="tab-right">
                            {activeTab === "letter" ? (
                                <Icon icon="weui:done2-filled" className="tab-right-icon" />
                            ) : (
                                <span className="tab-placeholder-icon" />

                            )}
                        </div>
                    </button>


                </div>


                {/* Render Selected Component */}
                <div className="mt-4">
                    {/* {activeTab === "empreson" && <EmployeeReson />} */}

                    {activeTab === "empreson" && (
                        <EmployeeReson
                            onCreated={(newRequestId) => {
                                setHasCreatedRequest(true);
                                setRequestId(newRequestId);
                                setActiveTab("cexitIntervie");
                            }}
                        />
                    )}

                    {/* {activeTab === "cexitIntervie" && <CompleteExitInterview setActiveTab={setActiveTab} />} */}

                    {activeTab === "cexitIntervie" && (
                        <CompleteExitInterview
                            requestId={requestId}
                            setActiveTab={setActiveTab}
                            onInterviewCompleted={() => {
                                setHasCompletedInterview(true);
                                setActiveTab("offboadringEmp");
                            }}
                        />
                    )}

                    {activeTab === "offboadringEmp" && <OffboardingEmployeeStatus setActiveTab={setActiveTab} />}



                </div>
            </div>

        </Layout>
    )
}

export default EmployeeOffboarding